import _regeneratorRuntime from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from "vuex";
import { resetRouter } from "@/router";
import { getAppId, setAppId } from "@/utils/auth";
export default {
  name: 'Apps',
  components: {},
  data: function data() {
    return {
      activeIndex: "1",
      lacApps: []
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(["apps", "appId"])), {}, {
    defaultTheme: function defaultTheme() {
      return this.$store.state.settings.theme;
    },
    topNavSetBg: function topNavSetBg() {
      return this.$store.state.settings.topNavSetBg;
    },
    topNavSetTextColor: function topNavSetTextColor() {
      return this.$store.state.settings.topNavSetTextColor;
    },
    topNavTextColor: function topNavTextColor() {
      return this.$store.state.settings.topNavTextColor;
    }
  }),
  created: function created() {},
  mounted: function mounted() {
    this.activeIndex = this.appid ? this.appid : getAppId();
    this.lacApps = this.apps && this.apps.length > 0 ? this.apps : JSON.parse(sessionStorage.getItem('SET_APPS'));
  },
  methods: {
    isLight: function isLight(rgb) {
      return 0.213 * rgb[0] + 0.715 * rgb[1] + 0.072 * rgb[2] > 255 / 2;
    },
    handleSelect: function () {
      var _handleSelect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(key, keyPath) {
        var isJump, menus, accessMenuRoutes;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              console.log(key, keyPath);
              isJump = this.apps.filter(function (item) {
                return item.id === key;
              });
              if (!this.lacApps.map(function (p) {
                return p.appName;
              }).some(function (p) {
                return p === isJump[0].appName;
              })) {
                _context.next = 6;
                break;
              }
              setAppId(isJump[0].id);
              location.href = isJump[0].indexUrl;
              return _context.abrupt("return");
            case 6:
              this.activeIndex = key;
              // 切换应用重置配置
              this.$store.commit("user/SET_ACCESSEDMENU", []);
              this.$store.commit("user/SET_ROLES", []);
              resetRouter();
              this.$store.dispatch("tagsView/delAllViews", null, {
                root: true
              });

              // 设置配置
              this.$store.commit("user/SET_APPID", key);
              setAppId(key);
              _context.next = 15;
              return this.$store.dispatch("user/getMenus", key);
            case 15:
              menus = _context.sent;
              _context.next = 18;
              return this.$store.dispatch("permission/generateMenuRoutes", menus);
            case 18:
              accessMenuRoutes = _context.sent;
              if (!(!accessMenuRoutes || accessMenuRoutes.length <= 0)) {
                _context.next = 21;
                break;
              }
              throw new Error("用户菜单权限获取失败，请重新登陆");
            case 21:
              this.$store.commit("user/SET_ACCESSEDMENU", accessMenuRoutes);
              this.$router.addRoutes(accessMenuRoutes);
              this.$router.push({
                path: '/',
                replace: true
              });
            case 24:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function handleSelect(_x, _x2) {
        return _handleSelect.apply(this, arguments);
      }
      return handleSelect;
    }()
  }
};